import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import dynamic from "next/dynamic";
const CertificatePage = dynamic(() => import("@/app/certificate"), {
  ssr: false,
});

const Certificate = () => {
  return <CertificatePage />;
};

export default Certificate;

export async function getStaticProps(context: any) {
  const { locale } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}
